<template>
  <div class="download universal">
    <h1 class="page-title">图文专栏 · {{date_content.length || 0}}</h1>
    <None
      v-if="date_content.length==null||date_content.length == 0"
      moreFind
      moreURL="https://download.csdn.net/list/blog"
      moreText="发现更多专栏"
    />
    <div v-else>
      <PicTextContentItem
        v-for="(item,index) in date_content"
        :key="item.id"
        :dateObject="item"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>
    <DevPagination
      class="margin-top-66"
      :total="date_content.length"
      :pageSize="10"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import PicTextContentItem from "@/components/Subscribe/PicTextContentItem.vue";
import None from "@/components/Base/None.vue";
import { getSubscibeList } from "@/utils/api";

export default {
  components: {
    DevPagination,
    PicTextContentItem,
    None,
  },
  data() {
    return {
      date_content: [],
      pageInfo: "",
    };
  },
  methods: {
    postDate(page) {
      this.pageInfo = page;
      this.$store.dispatch("changeLoading", true);
      getSubscibeList({
        page: page.current,
        pageSize: page.pageSize,
      }).then((response) => {
        this.date_content = response.data;
        this.$store.dispatch("changeLoading", false);
      });
    },
  },
};
</script>

<style lang="less" scoped>
.download {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
